<template>
    <v-col>
        <div class="wrapper">
            <div class="wrap-filters primary">
                <v-row align="center">
                    <v-col cols="12" md="8" sm="5">
                        <h1>{{ $t("tours_types.tours_types") }}</h1>
                    </v-col>
                </v-row>
                <v-btn
                    color="secondary"
                    class="btn-add floating-btn"
                    elevation="0"
                    @click="$router.push({ name: 'tours_types_new' })"
                >
                    <v-icon size="18">mdi-plus</v-icon>
                    {{ $t("global.add") }}
                </v-btn>
            </div>

            <div class="wrap-datables">
                <v-row>
                    <v-col cols="12" md="6" sm="12">
                        <v-text-field
                            v-model="search"
                            :label="$t('global.search')"
                            append-icon="mdi-magnify"
                            dense
                            hide-details="auto"
                            light
                            outlined
                            single-line
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :custom-filter="customFilter"
                            :footer-props="{
                                'items-per-page-options': [
                                    25, 50, 100, 500, -1,
                                ],
                            }"
                            :headers="headers"
                            :items="tour_types"
                            :items-per-page="25"
                            :search="search"
                        >
                            <template #[`item.dates`]="{ item }">
                                <span v-if="item.start_date">
                                    {{
                                        $t('tours_types.from_to',
                                            [
                                                item.start_date.toDate(),
                                                item.end_date.toDate()
                                            ]
                                        )
                                    }}
                                </span>
                                <span v-else> - </span>
                            </template>
                            <template #[`item.days`]="{ item }">
                                {{ formatDays(item) }}
                            </template>

                            <template #[`item.actions`]="{ item }">
                                <v-btn
                                    class="see ma-1"
                                    icon
                                    small
                                    dark
                                    @click="
                                        $router.push({
                                            name: 'tours_types_edit',
                                            params: { id: item.id },
                                        })
                                    "
                                >
                                    <v-icon size="16">mdi-eye</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-col>
</template>

<script>
export default {
    name: "ToursTypes",
    data() {
        return {
            tour_types: [],
            search: "",
            headers: [
                {
                    text: this.$t("tours_types.designation"),
                    align: "start",
                    sortable: true,
                    value: "designation",
                },
                {
                    text: this.$tc("tours_types.days", 2),
                    align: "start",
                    value: "days",
                },
                {
                    text: this.$tc("tours_types.dates", 2),
                    align: "start",
                    sortable: true,
                    value: "dates",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                },
            ],
        };
    },
    async mounted() {
        await this.$api.tour_types.all().then(({data: tour_types}) => this.tour_types = tour_types.data)
    },
    methods: {
        formatDays(item) {
            const days = [
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
                'sunday',
            ]

            let availableDays = []
            for (let day of days) {
                if (item[`is_${day}`]) {
                    availableDays.push(this.$t(`tours_types.${day}`))
                }
            }

            return availableDays.join(', ')
        },
        customFilter(value, search, item) {
            return (
                item.designation.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
                this.formatDays(item).toLocaleLowerCase().includes(search.toLocaleLowerCase())
            )
        }
    },
};
</script>
